import React from 'react';
import PropTypes from 'prop-types';

const ButtonsContainer = ({ handleClose, handleSubmit, saveButtonDisabled }) => (
  <div className="button-container">
    <button
      className="button sm tertiary t-cancel-modal"
      onClick={() => handleClose()}
      type="button"
    >
      {t('Cancel')}
    </button>
    <button
      className="button sm primary t-confirm-modal"
      disabled={saveButtonDisabled}
      onClick={handleSubmit}
      type="button"
    >
      {t('Save')}
    </button>
  </div>
);

ButtonsContainer.propTypes = {
  handleClose: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  saveButtonDisabled: PropTypes.bool.isRequired,
};

export default ButtonsContainer;
